import { render } from "./curtain_modal.vue?vue&type=template&id=1d904a70&scoped=true"
import script from "./curtain_modal.vue?vue&type=script&lang=js"
export * from "./curtain_modal.vue?vue&type=script&lang=js"

import "./curtain_modal.vue?vue&type=style&index=0&id=1d904a70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d904a70"]])

export default __exports__